import { DotsHorizontal, MessageAlertCircle } from '@/components/common/icons';
import LeftNavActionButton from '@/components/common/pageLayout/LeftNavActionButton';
import { showInviteModal } from '@/components/partnershipInvites/InviteModal';
import { showCancelPartnershipInviteModal } from '@/components/settings/CancelPartnershipInviteModal';
import { showResendPartnershipInviteModal } from '@/components/settings/ResendPartnershipInviteModal';
import { DarkMode, Menu, MenuItem, MenuList } from '@chakra-ui/react';
import { assert } from '@common/errors';
import { getCanResendInvite } from '@common/partnerships';
import { isSingleplayer, useCurrentUser } from '@common/react/user';
import { dt } from '@common/util/dateTime';
import useLocalStorageState from 'use-local-storage-state';
import { MenuButton } from '../common/Button';
import { showAcceptInvitePartnerModal } from './AcceptInviteModal';

const PartnerInviteButton = () => {
    // TODO: Persist this in the DB as part of https://linear.app/plenty/issue/PLE-1158/user-feature-interactions
    const [isButtonDismissed, setButtonDismissed] =
        useLocalStorageState<boolean>('isPartnerInviteButtonDismissed', {
            defaultValue: false,
        });
    const currentUser = useCurrentUser();
    const {
        outgoingPartnershipInvite,
        incomingPartnershipInvite,
        partnerInfo,
    } = currentUser;

    if (
        ((isButtonDismissed || isSingleplayer(currentUser)) &&
            !outgoingPartnershipInvite &&
            !incomingPartnershipInvite) ||
        partnerInfo?.userId
    )
        return null;

    let label = 'Invite your partner';
    let onClick: VoidFunction | undefined = showInviteModal;
    if (outgoingPartnershipInvite) {
        label = 'Partner invited';
        onClick = undefined;
    } else if (incomingPartnershipInvite) {
        label = incomingPartnershipInvite.inviterName + ' invited you';
        onClick = showAcceptInvitePartnerModal;
    }

    return (
        <LeftNavActionButton
            text={label}
            onClick={() => onClick?.()}
            onClickEvent="Partner Invite Left Nav Action Button Clicked"
            icon={
                incomingPartnershipInvite ? (
                    <MessageAlertCircle color="green.500" />
                ) : (
                    <DarkMode>
                        <Menu placement="right" gutter={30}>
                            <MenuButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                onClickEvent="Partner Invite Menu Button Clicked"
                                onClickEventParams={{ label }}
                            >
                                <DotsHorizontal color="gray.600" />
                            </MenuButton>
                            <MenuList>
                                {outgoingPartnershipInvite ? (
                                    <>
                                        {getCanResendInvite(
                                            dt(
                                                outgoingPartnershipInvite.expiresAt
                                            )
                                        ) && (
                                            <MenuItem
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    assert(
                                                        outgoingPartnershipInvite.id
                                                    );
                                                    showResendPartnershipInviteModal(
                                                        {
                                                            partnershipInviteId:
                                                                outgoingPartnershipInvite.id,
                                                        }
                                                    );
                                                }}
                                            >
                                                Resend invite
                                            </MenuItem>
                                        )}
                                        <MenuItem
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                assert(
                                                    outgoingPartnershipInvite.id
                                                );
                                                showCancelPartnershipInviteModal(
                                                    {
                                                        partnershipInviteId:
                                                            outgoingPartnershipInvite.id,
                                                    }
                                                );
                                            }}
                                        >
                                            Cancel invite
                                        </MenuItem>
                                    </>
                                ) : (
                                    <>
                                        <MenuItem
                                            onClick={() => showInviteModal()}
                                        >
                                            Send invitation
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setButtonDismissed(true);
                                            }}
                                        >
                                            Dismiss this button
                                        </MenuItem>
                                    </>
                                )}
                            </MenuList>
                        </Menu>
                    </DarkMode>
                )
            }
        />
    );
};

export default PartnerInviteButton;
